// label-utils.js - Utilitários simplificados para manipulação de labels

// Paleta de cores para labels
export const LABEL_COLORS = [
  "#3498db", // Azul claro
  "#2ecc71", // Verde esmeralda
  "#e74c3c", // Vermelho pomegranate
  "#9b59b6", // Roxo ametista
  "#f1c40f", // Amarelo sol
  "#1abc9c", // Verde turquesa
  "#e67e22", // Laranja cenoura
  "#34495e", // Azul escuro
  "#d35400", // Laranja escuro
  "#8e44ad", // Roxo escuro
];

// Função para determinar a cor do texto com base na cor de fundo
export const getContrastColor = (hexColor) => {
  // Converte a cor hex para RGB
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  // Calcula a luminância percebida
  // Fórmula: 0.299*R + 0.587*G + 0.114*B
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Retorna preto para cores claras, branco para cores escuras
  return luminance > 0.5 ? "#000000" : "#FFFFFF";
};

// Função para obter uma cor aleatória da paleta
export const getRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * LABEL_COLORS.length);
  return LABEL_COLORS[randomIndex];
};
